import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import { FaCalendar } from "@react-icons/all-files/fa/FaCalendar"
import { SectionContext } from "../../context/sectionContext"
import { ConditionContext } from "../../context/conditionContext"
import { JourneyContext } from "../../context/journeyContext"
import { getValueFromJourney } from "../../services/helperFunctions"
import { lineCapital } from "../../../shared/functions"
import * as moment from "moment"
import { dateFormat2, dateFormat1 } from '../../../shared/constant'
import { ErrorContext } from "../../context/errorContext"

import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import range from "lodash/range"
import { getYear, getMonth } from "date-fns"
import { isIE } from 'react-device-detect';
const years = range(1920, getYear(new Date()) + 1, 1)
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]


const DateContainer = styled.div`
  display: block;
  flex-direction: column;
  margin: 15px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;

  & > .date-input {
    display: flex;
    position: relative;
    border: 1px solid #929292;
    padding:0;
    padding-left: 10px;
    z-index:2;
    .react-datepicker-popper{
      transform: translate(26px, 69px) scale(1.2) !important;
      left:8rem !important;
      @media screen and (max-width:767px){
        transform: translate(26px,69px) scale(1.2) !important;
        left: 4rem !important;
      }
    }
    input {
      width: 100%;
      border: none;
      outline: none;
      z-index: 5;
      background: transparent;
      
      &:before{
        content: attr(value);
      }


      &[value=""]:before{
        content: attr(format);
      }


      &::-webkit-calendar-picker-indicator {
        color: rgba(0, 0, 0, 0);
        opacity: 0;
        cursor: pointer;
      }
      &::-webkit-datetime-edit, &::-webkit-inner-spin-button, &::-webkit-clear-button {
        opacity: 0;
      }

    }

    .input-icon {
      position: absolute;
      right: 1rem;
      cursor: pointer;
      bottom: -5px;
      & > * {
        color: ${props => props.channel === "A" || props.channel === "28" || props.channel === "35" || props.channel === "39" ? "#db0011" : props.channel === "B" ? "#a20a3a" : props.channel === "C" ? "#fec32b" : "#eb7f25"};
        color: var(--lumiq-tertiary);
      }
    }
  }

  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background: ${props => props.channel === "A" || props.channel === "28" || props.channel === "35" || props.channel === "39" ? "#ededed" : "#fff"};
    background:var(--lumiq-bg);
    padding: 2px 5px;
    z-index: 3;
    position: relative;
    display: inline-block;
    cursor: default;
    max-width: 100%;
  }

  &.required-field::before {
    content: "*";
    color: red;
    position: absolute;
    top: 9px;
    left: 0px;
    font-size: 18px;
    line-height: 1;
    z-index: 4;
  }

  @media (max-width: 767px) {
    &.required-field::before {
      top: 5px;
      left: 0px;
      font-size: 15px;
    }
  }
`
export default function RepeatableComponentTextInputDate(props) {
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [errorState, setErrorState] = useContext(ErrorContext)
  const [showLocalError, setShowLocalError] = useState(false)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  let pickerRef = React.createRef();

  const getMaxDate = () => {
    if (props.data.max_age) {
      let currentDate = new Date()
      let maxDateInEpoch = currentDate.setDate(currentDate.getDate() - props.data.max_age)
      let maxDate = new Date(maxDateInEpoch)
      return maxDateInEpoch
    } else {
      return
    }
  }
  const getMinDate = () => {
    if (props.data.min_age) {
      let currentDate = new Date()
      let minDateInEpoch = currentDate.setDate(currentDate.getDate() - props.data.min_age)
      let minDate = new Date(minDateInEpoch)
      return minDateInEpoch
    } else {
      return
    }
  }

  const validate = (target) => {
    let temp
    let temp1
    if (errorState[props.data.formControlKey]) {
      temp1 = errorState[props.data.formControlKey]
    } else {
      temp1 = []
    }
    if (props.data.required) {
      //   required field validation
      if (!sectionState.sectionData[props.data.formControlKey] || !sectionState.sectionData[props.data.formControlKey][props.index]) {
        // console.log("dchdh1", props, sectionState)
        temp1[props.index] =  (getValueFromJourney(
              journeyState.lookup.required_error,
              props.data.requiredError
            ))
        temp = temp1
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: temp
          })
        })
        return
      }
      if ((sectionState.sectionData[props.data.formControlKey]) && (!sectionState.sectionData[props.data.formControlKey][props.index])) {
        temp1[props.index] =  (getValueFromJourney(
              journeyState.lookup.required_error,
              props.data.requiredError
            ))
        temp = temp1
        setErrorState(prev => {
          // console.log("dchdh2", props, sectionState)
          return ({
            ...prev,
            [props.data.formControlKey]: temp
          })
        })
      } else {
        temp1[props.index] = ""
        temp = temp1
        setErrorState(prev => {
          // console.log("dchdh3", props, sectionState)
          return ({
            ...prev,
            [props.data.formControlKey]: temp
          })
        })
      }
      if (target.value) {
        // console.log("dchdh4", props, sectionState)
        temp1[props.index] = ""
        temp = temp1
        setErrorState(prev => {
          return ({
            ...prev,
            [props.data.formControlKey]: temp
          })
        })
      }
    }
    if (target.value) {
      // console.log("insid eseconf if vj", target.value)
      let targetDateInEpoch = target.value

      let currentDateInEpoch = Math.floor((new Date().getTime()) / 1000)
      let timeleft = currentDateInEpoch - targetDateInEpoch
      let days = Math.ceil(((timeleft / 60) / 60) / 24)
      // console.log("time", currentDateInEpoch, targetDateInEpoch, timeleft)

      if (props.data.min_age) { // min age validation
        console.log("inside min age")
        if (days > props.data.min_age) {
          temp1[props.index] =  (getValueFromJourney(
            journeyState.lookup.min_error,
            props.data.min_age_error
          ))

          temp = temp1
          setErrorState(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: temp
            })
          })
          setShowLocalError(true)
          return
        } else {
          temp1[props.index] = ""
          temp = temp1
          setErrorState(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: temp
            })
          })
        }
      }
      if (props.data.max_age) { //max age validation
        // console.log("inside max age", days, props.data.max_age)
        if (days < props.data.max_age) {
          temp1[props.index] =  (getValueFromJourney(
            journeyState.lookup.max_error,
            props.data.max_age_error
          ))

          temp = temp1
          setErrorState(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: temp
            })
          })
          setShowLocalError(true)
          return
        }
        else {
          temp1[props.index] = ""
          temp = temp1
          setErrorState(prev => {
            return ({
              ...prev,
              [props.data.formControlKey]: temp
            })
          })
        }
      }
    }
    // console.log(errorState)
    return
  }


  useEffect(() => {
    validate({
      value: (sectionState.sectionData[props.data.formControlKey] ? sectionState.sectionData[props.data.formControlKey][props.index] ?? "" : "")
    })

    handlePicker()

  }, [sectionState.sectionData[props.data.formControlKey]?.[props.index]])

  const handleChange = (target ) => {
    console.log("22322323", target)
    let dateOfTargetInEpoch = (new Date(target).getTime())/1000
    console.log("223223232",dateOfTargetInEpoch)
    let temp
    if (sectionState.sectionData[props.data.formControlKey]) {
      let temp1 = sectionState.sectionData[props.data.formControlKey]
      temp1[props.index] = dateOfTargetInEpoch
      temp = temp1
    } else {
      let temp1 = []
      temp1[props.index] = dateOfTargetInEpoch
      temp = temp1
    }
    if (sectionState.sectionId === props.sectionId) {
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: temp
          },
        }
      })
    } else {
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: props.sectionId,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: temp
          },
        }
      })
    }

    setConditionState(prev => {
      return {
        ...prev,
        [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: temp,
      }
    })
    validate({value: dateOfTargetInEpoch})
    console.log(sectionState, "section state")
  }

  const handlePicker = () => {


    if(pickerRef?.current){

      let picker = pickerRef?.current.querySelector('.input-icon')
      let calender = pickerRef?.current.querySelector('#datepicker')
      
      picker.addEventListener('click',()=>{
        calender.click()
      })
    }
  }

  return (
    <>
      <DateContainer channel={props.channel} className={`form-group input-container ${props.data.required ? "required-field" : ""}`}>
        <label htmlFor={props.data.id} className="input-label" >{(getValueFromJourney(
          journeyState.lookup.label,
          props.data.label
        )) || props.data.label}</label>
        <div ref={pickerRef} className="date-input form-control">
        <DatePicker
        id="datepicker"

  selected={(sectionState.sectionData[props.data.formControlKey] && sectionState.sectionData[props.data.formControlKey][props.index])
    ? sectionState.sectionData[props.data.formControlKey][props.index] * 1000
    : ""}
  dateFormat={'dd/MMM/yyyy'}
  placeholderText={(getValueFromJourney(
    journeyState.lookup.placeholder,
    props.data.placeholder
  )) || props.data.placeholder}
  className={(isIE ? 'IELineHeight' : '')}
  autoComplete ="false"
  renderCustomHeader={({
    date,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
  }) => (
    <div
      style={{
        margin: 10,
        display: "flex",
        justifyContent: "center",
      }}
    >
      <button
        onClick={decreaseMonth}
        disabled={prevMonthButtonDisabled}
      >
        {"<"}
      </button>
      <select
        value={getYear(date)}
        onChange={({ target: { value } }) => changeYear(value)}
      >
        {years.map(option => (
          <option className="datepicker-option" key={option} value={option}>
            {option}
          </option>
        ))}
      </select>

      <select
        value={months[getMonth(date)]}
        onChange={({ target: { value } }) =>
          changeMonth(months.indexOf(value))
        }
      >
        {months.map(option => (
          <option className="datepicker-option" key={option} value={option}>
            {option}
          </option>
        ))}
      </select>

      <button
        onClick={increaseMonth}
        disabled={nextMonthButtonDisabled}
      >
        {">"}
      </button>
    </div>
  )}
  minDate={getMinDate()}
  maxDate={getMaxDate()}
  // onSelect={handleDateSelect} //when day is clicked
  onChange={handleChange} //only when value has changed
/>
          {/* <input
            type="date"
            format={dateFormat1}
            placeholder={props.data.placeholder}
            name={props.data.id}
            required={props.data.required}
            disabled={props.data.disabled}
            onChange={handleChange}
            value={
              (sectionState.sectionData[props.data.formControlKey] && sectionState.sectionData[props.data.formControlKey][props.index])
                ? moment.unix(
                  sectionState.sectionData[props.data.formControlKey][props.index]
                ).utcOffset("+05:30").format(dateFormat1).split('T')[0]
                : ""
            }
            min={getMinDate()}
            max={getMaxDate()}
          //dateFormat={props.data.dateFormat}
          //formControlKey={props.data.formControlKey}
          ></input> */}
          <span className="input-icon" aria-hidden="true" onClick={()=>handlePicker()}  >
            <FaCalendar  />
          </span>
        </div>
        <span className="input-error2">
          {(props.showError || showLocalError) && errorState?.[props.data.formControlKey]?.[props.index]}
        </span>
      </DateContainer>
    </>
  )
}
